import { Controller } from "@hotwired/stimulus"

// Reusable confirm modal: open/close a dialog target (no browser confirm).
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    this.dialogTarget.classList.remove("hidden")
    setTimeout(() => this.dialogTarget.classList.add("opacity-100"), 10)
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    if (this.dialogTarget.getAttribute("aria-busy") === "true") return
    this.dialogTarget.classList.remove("opacity-100")
    setTimeout(() => this.dialogTarget.classList.add("hidden"), 200)
  }

  closeBackdrop(event) {
    if (event.target === event.currentTarget) this.close(event)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
